export default function Bolt(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.2444 2.65625H5.75833L1.52344 10L5.75833 17.3438H14.2444L18.4793 10L14.2444 2.65625Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M6.73438 9.99997C6.73438 10.8656 7.07825 11.6958 7.69035 12.3079C8.30244 12.92 9.13263 13.2639 9.99826 13.2639C10.8639 13.2639 11.6941 12.92 12.3062 12.3079C12.9183 11.6958 13.2622 10.8656 13.2622 9.99997C13.2622 9.13434 12.9183 8.30415 12.3062 7.69206C11.6941 7.07996 10.8639 6.73608 9.99826 6.73608C9.13263 6.73608 8.30244 7.07996 7.69035 7.69206C7.07825 8.30415 6.73438 9.13434 6.73438 9.99997Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	)
}
